export const ACCESS_RIGHTS = {

    //#region CORE
    CORE_SECURITY_USERS: 1001,
    CORE_SECURITY_ROLES: 1002,
    CORE_SECURITY_AUDIT_LOGS: 1003,
    CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER: 1004,
    CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR: 1005,
    CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER: 1006,
    //#endregion

    //#region NATIONAL ACADEMY OF SPORTS
    NAS_STATICDATA_BUILDING_LOCATIONS: 2201,
    NAS_STATICDATA_GUIDANCE_COUNSELOR_SESSION_TYPES: 2202,
    NAS_STATICDATA_CLINIC_VISIT_TYPES: 2203,
    NAS_STATICDATA_CLOCK_IN_DEVICES: 2204,
    NAS_STATICDATA_GRADE_LEVELS: 2205,
    NAS_STATICDATA_SECTIONS: 2206,
    NAS_STATICDATA_RFID_CARDS: 2207,
    NAS_STATICDATA_ROOMS: 2208,
    NAS_STATICDATA_SPORTS: 2209,
    NAS_STATICDATA_GUIDANCEVISITTYPES: 2210,

    NAS_STUDENTS: 2301,
    NAS_STUDENTS_ASSIGN_RFID: 2302,
    NAS_STUDENTS_REMOVE_RFID: 2303,
    NAS_TRANSACTIONS_CHECK_INS: 2304,
    NAS_TRANSACTIONS_CLINIC_VISITS: 2305,
    NAS_TRANSACTIONS_GUIDANCE_COUNSELOR_VISITS: 2306,
    NAS_TRANSACTIONS_DORMITORY_VISITS: 2307,
    NAS_STUDENTS_MEDICAL_INFO: 2308,
    //#endregion
} 